<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="products_group"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="productsGroupForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Group Produk Listing"
          addButton="Tambah Group Produk"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Group Produk Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Group Produk</h3>
          </div>

          <b-form id="productsGroupForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Group">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.productsGroupForm.name.$model"
                      :state="!$v.productsGroupForm.name.$invalid"
                      required
                      placeholder="Nama Group"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Group harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                 <b-form-group label-for="prefix" label="Prefix">
                    <b-form-input
                      id="prefix"
                      type="text"
                      v-model="$v.productsGroupForm.prefix.$model"
                      :state="!$v.productsGroupForm.prefix.$invalid"
                      required
                      placeholder="Prefix"
                    ></b-form-input>
                    <b-form-invalid-feedback>Prefix harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.productsGroupForm.description.$model"
                      :state="!$v.productsGroupForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.productsGroupForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "products_group",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      products_group: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        { key: "name", label: "Nama Grup", sortable: true },
        { key: "prefix", label: "Prefix" },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "text-center width-80" }
      ],
      productsGroupForm: masterInterfaces.products_group,
      isEdit: false
    };
  },
  validations: {
    productsGroupForm: {
      name: { required },
      prefix: { required },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getProductsGroup();
    },
    getProductsGroup: function() {
      this.axios
        .get("web/master/products_group/all/")
        .then(response => {
          this.products_group = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
   
    editForm: function(e) {
      this.isEdit = true;
      this.productsGroupForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.products_group) {
        masterInterfaces.products_group[a] = null;
      }
      this.productsGroupForm = masterInterfaces.products_group;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.resetForm();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah group konsumen ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/products_group/edit/", this.productsGroupForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Group Konsumen Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, 'Ubah group konsumen');
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan group konsumen ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/products_group/add/", this.productsGroupForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Group Produk Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Group Produk Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, 'Tambah group konsumen');
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  